import { render } from "./cryptoPay.vue?vue&type=template&id=3c2a1f48&scoped=true"
import script from "./cryptoPay.vue?vue&type=script&lang=js"
export * from "./cryptoPay.vue?vue&type=script&lang=js"

import "./cryptoPay.vue?vue&type=style&index=0&id=3c2a1f48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2a1f48"]])

export default __exports__